<script>
	import { textInstructions } from "../placeholderText.js";
	export let conditions;
	let studyInstructions = [];

	const iconOn = "&#128993;";
	const iconOff = "&#9898;";
	let icons = [];
	let iconMain = iconOn;

	const getStorage = (conditions) => {
		let params = JSON.parse(localStorage.getItem("createStudyParams"));
		if (params) {
			if (params.studyInstructions) {
				studyInstructions = params["studyInstructions"];
			}
		} else {
			params = {};
		}
		// if no parameters in localStorage yet, create and populate it with default value
		if (!studyInstructions) {
			studyInstructions = [];
			for (let i = 0; i < conditions; i++) {
				studyInstructions.push(textInstructions);
				icons.push(iconOn);
			}
		} else {
			// if parameters in localStorage, check if it has the right number of conditions
			if (studyInstructions.length < conditions) {
				// if not, add the missing conditions
				for (let i = studyInstructions.length; i < conditions; i++) {
					studyInstructions.push(textInstructions);
					icons.push(iconOn);
				}
			}
		}
		params["studyInstructions"] = studyInstructions;
		localStorage.setItem("createStudyParams", JSON.stringify(params));
	};
	getStorage();
	$: getStorage(conditions);

	const updateStorage = (parameters) => {
		let params = JSON.parse(localStorage.getItem("createStudyParams"));
		params["studyInstructions"] = parameters;
		localStorage.setItem("createStudyParams", JSON.stringify(params));
	};
	$: updateStorage(studyInstructions);

	const toggleInstructionsButtons = (condition) => {
		if (condition === -1) {
			// toggle instructions for all conditions
			let instruct = "";
			if (iconMain === iconOff) {
				iconMain = iconOn;
				instruct = textInstructions;
			} else {
				iconMain = iconOff;
				instruct = "";
			}
			for (let i = 0; i < conditions; i++) {
				icons[i] = iconMain;
				studyInstructions[i] = instruct;
			}
		} else {
			// toggle instructions for a specific condition
			if (studyInstructions[condition] === "") {
				studyInstructions[condition] = textInstructions;
				icons[condition] = iconOn;
			} else {
				studyInstructions[condition] = "";
				icons[condition] = iconOff;
			}
		}
		updateStorage(studyInstructions);
	};

	const formatForAPI = (conditions, parameters, parameterName) => {
		let paramsSelected = JSON.parse(
			localStorage.getItem("createStudyParamsSelected")
		);
		let formatted = [];
		for (let i = 0; i < conditions; i++) {
			formatted.push({
				condition: i + 1,
				param: parameterName,
				value: parameters[i],
			});
		}
		if (paramsSelected) {
			paramsSelected[parameterName] = formatted;
		} else {
			paramsSelected = {};
			paramsSelected[parameterName] = formatted;
		}
		localStorage.setItem(
			"createStudyParamsSelected",
			JSON.stringify(paramsSelected)
		);
	};
	$: formatForAPI(conditions, studyInstructions, "instruct");
</script>

<hr />
<h3>Study instructions</h3>
<p>
	Instructions to show at the start of the study (popup/modal). Use <strong
		>Markdown</strong
	>
	if you want to format/edit the text. Click
	<a href="#" on:click|preventDefault={() => toggleInstructionsButtons(-1)}>
		{@html iconMain}
	</a>to toggle instructions on/off.
</p>

{#each { length: conditions } as _, ii}
	<p>
		<strong>Condition {ii + 1}</strong>&nbsp;<a
			href="#"
			on:click|preventDefault={() => toggleInstructionsButtons(ii)}
		>
			{@html icons[ii]}</a
		>
	</p>
	<div>
		<label for={"condition-" + (ii + 1) + ";instruct"} />
		<textarea
			bind:value={studyInstructions[ii]}
			name={"condition-" + (ii + 1) + ";instruct"}
			rows="4"
			cols="50"
		/>
	</div>
{/each}

<style>
	label {
		margin-bottom: 13px;
		font-size: 1.1em;
	}
	textarea {
		width: 89%;
		height: 89px;
	}
</style>
